import { React, useContext } from "react";
import { Link } from "react-router-dom";
import { PageContext } from "../../App";

function ExploreAppsList() {
  //get context
  const { appListShowing } = useContext(PageContext);

  return (
    <div className="mx-3 mt-5">{appListGridView(appListShowing)}</div>
  );
}

/* Apps List View */
function appListGridView(appListItems) {
  return (
    <div className="row row-cols-md-4 row-cols-sm-3 row-cols-1 justify-content-center mx-md-2 mx-0">
      {appListItems.map((item) => (
       <Link
  key={item.id}
  to={item.navigate}
  state={item.state}
  className="bg-light m-md-1 m-sm-1 m-1 rounded-1 border d-block text-decoration-none text-dark"
>
  {/* Online offline circle */}
  <div className="d-flex justify-content-between mt-2 mb-2 ps-2 pe-2 pt-1 pb-1 align-items-center">

    {/* Name */}
    <div className="d-flex justify-content-center align-items-center">

      {/* Image */}
      <img
        loading="lazy"
        src="./images/circle-fill.svg"
        alt=""
        aria-hidden="true"
        style={{
          filter: item.online
            ? "invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)"
            : "brightness(0) saturate(100%) invert(60%) sepia(63%) saturate(6138%) hue-rotate(165deg) brightness(99%) contrast(102%)",
          width: "16px",
          height: "auto",
          maxWidth: "16px",
        }}
      />

      {/* Name */}
      <h4 className="fs-6 fw-bold ms-2 my-auto">
        {item.name}
      </h4>
    </div>

    {/* Right arrow */}
    <img
      loading="lazy"
      style={{ width: "10px", height: "16px" }}
      src="./images/arrow_right.png"
      alt=""
    />
  </div>

  {/* Description */}
  <div>
    <p className="fs-7 text-muted ps-2 pe-4 pb-5 mb-0">
      {item.subtitle}
    </p>
  </div>
</Link>
      ))}
    </div>
  );
}

export default ExploreAppsList;
